import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {
  createSystem,
  ISyncPointPrefab,
  buildWorld,
  IEntity,
  Entity
} from '@IntrinsicSoftware/sim-ecs';
import {
  CompletableViewModelSystem,
  CompletableSystem,
  SetCompletableActiveStateSystem,
  Completable,
  CompletableSynchronizationComponent,
  useChecklist
} from '../ecs/completable/Completable';
import { Description } from '../ecs/description/main';
import Timer, { DATE_MAX, TimerSystem } from '../ecs/timer/main';
import RecursiveChecklistItemComponent from '../components/system/components/checklist/RecursiveChecklistComponent.vue';
import { Worth } from '../ecs/point/main';

export default /*#__PURE__*/_defineComponent({
  __name: 'EcsPage',
  setup(__props) {

/*
Mighty Pirate's TODO List
() Get the five keys for the safe
--Acquire Widey's Golden Key (slashed out)
----Acquire Widey's stolen Golden Key (ACTIVE)
--Acquire Old Mrs. Smith's Golden Key (CHECKMARK)
--Acquire Bella Fisher's Golden Key (ACTIVE)
----Get the flag from the fish shop (CHECKMARK)
------Become a high ranking chum (CHECKMARK)
----Get the museum's flag (CHECKMARK && slashed out)
----Get the museum's REAL flag (CHECKMARK && slashed out)
----Get the quarantine ship flag (ACTIVE)
--Acquire the Brrr Muda Island Golden Key (ACTIVE)
----Become the Queen (ACTIVE)
------Win the Contest of Heartiness (CHECKMARK)
------Win the Contest of Intelligence (CHECKMARK)
------Win the Contest of Seriousness (ACTIVE)
--Acquire the Terror Island Golden Key (ACTIVE)
Get a map of the sea (CHECKMARK)
Help Elaine get a better scurvy flyer (ACTIVE)
--Get Stan to help with Elaine's flyer (ACTIVE)
Find The Secret of Monkey Island in relive the glory days! (ACTIVE)
*/
const viewModelSystems = [CompletableViewModelSystem()];

const TickSystem = createSystem({
  interval: 100
})
  .withRunFunction(({ interval }) => {
    setTimeout(() => {
      world.dispatch();
    }, interval);
  })
  .build();
const executionSchedule: ISyncPointPrefab = {
  stages: [
    [TimerSystem(), CompletableSystem(), SetCompletableActiveStateSystem()],
    [...viewModelSystems],
    [TickSystem]
  ]
};
const SECONDS = 1000;
const THREE_SECONDS = 3 * SECONDS;

const world = buildWorld()
  .name('CompletableConstraintWorld')
  .withDefaultScheduling((root) => root.fromPrefab(executionSchedule))
  .withComponent(Completable)
  .withComponent(CompletableSynchronizationComponent)
  .build();

function createChecklistItem(
  title: string,
  description: string,
  points: number,
  timeLimit: number,
  children: IEntity[] = [],
  constraint: 'on self' | 'on children',
  uuid: string | undefined = undefined
) {
  const checklistItem = new Entity(uuid);
  checklistItem.addComponent(new Completable(children, constraint));
  checklistItem.addComponent(new Description(title, description));
  checklistItem.addComponent(new Worth(points));
  checklistItem.addComponent(new Timer(timeLimit, DATE_MAX));
  return checklistItem;
}
const checklistEntity = new Entity();
const checklistItemFour = createChecklistItem(
  'Node(4) => ()',
  "Node 4 dependent on () with constraint 'on self'",
  9001,
  THREE_SECONDS + 1 * SECONDS,
  [],
  'on self',
  '4'
);
const checklistItemThree = createChecklistItem(
  'Node(3) => ()',
  "Node 3 dependent on () with constraint 'on self'",
  9001,
  THREE_SECONDS + 1 * SECONDS,
  [],
  'on self',
  '3'
);
const checklistItemTwo = createChecklistItem(
  'Node(2) => (3, 4)',
  "Node 2 dependent on Node(3) and Node(4) with constraint 'on children'",
  9001,
  THREE_SECONDS + 1 * SECONDS,
  [checklistItemThree, checklistItemFour],
  'on children',
  '2'
);
const checklistItemOne = createChecklistItem(
  'Node(1) => (2)',
  'Node(1) dependent on No',
  9000,
  THREE_SECONDS,
  [checklistItemTwo],
  // 'on self',
  'on children',
  '1'
);

const checklistItemWildCard = createChecklistItem(
  'Node(*) => (3, 4)',
  "Node * dependent on Node(3) and Node(4) with constraint 'on children'",
  9001,
  THREE_SECONDS + 1 * SECONDS,
  [checklistItemThree, checklistItemFour],
  'on children',
  '*'
);

checklistEntity.addComponent(new Completable([checklistItemOne]));
checklistEntity.addComponent(new Timer());
checklistEntity.addComponent(
  new Description('Significant WX QRC', 'no description')
);
world.addEntity(checklistEntity);
world.addEntity(checklistItemOne);
world.addEntity(checklistItemTwo);
world.addEntity(checklistItemThree);
world.addEntity(checklistItemFour);
world.addEntity(checklistItemWildCard);

world.dispatch();

const checklistEntityComposable = useChecklist(checklistEntity);
// const items = [
//   useCompletable(checklistItemOne),
//   useCompletable(checklistItemTwo),
//   useCompletable(checklistItemThree),
//   useCompletable(checklistItemFour),
//   useCompletable(checklistItemWildCard)
// ];

setTimeout(() => {
  const component = checklistItemFour.getComponent(Completable);
  if (component) {
    component.value = true;
  }
}, 3000);

setTimeout(() => {
  const component = checklistItemThree.getComponent(Completable);
  if (component) {
    component.value = true;
  }
}, 6000);

setTimeout(() => {
  const component = checklistItemOne.getComponent(Completable);
  if (component) {
    component.value = true;
  }
}, 9000);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(RecursiveChecklistItemComponent, { checklistItem: _unref(checklistEntityComposable) }, null, 8, ["checklistItem"]))
}
}

})